import React, { useState } from "react";
import Slider from "react-slick";
import { useTranslation } from "../../context/translation";


type SlickSliderControlsProps = {
  sliderRef?: React.MutableRefObject<Slider | undefined>;
  autoPlay?: boolean;
  showPause?: boolean;
  showArrows?: boolean
  showDots?: boolean;
  slideCount?: number
  activeSlide?: number;
};

export default function SlickSliderControls({
                                              sliderRef,
                                              autoPlay = true,
                                              showPause = false,
                                              showArrows = false,
                                              showDots = false,
                                              slideCount = 0,
                                              activeSlide = 0
                                            }: SlickSliderControlsProps) {
  const { translate } = useTranslation();
  const [playing, setPlaying] = useState(autoPlay);

  const playPause = () => {
    if (playing) {
      sliderRef?.current?.slickPause();
      setPlaying(false);
    } else {
      sliderRef?.current?.slickPlay();
      setPlaying(true);
    }
  };

  return (
    <div className="slick-slide-controls">
      {showArrows && (
        <div className="slick-arrow-container">
          <button className="prev-control" onClick={() => sliderRef?.current?.slickPrev()} aria-label={translate('mam.blocks.slider.control.prev')} tabIndex={0}>
            <span className="mam-ico21" />
          </button>
          <button className="next-control" onClick={() => sliderRef?.current?.slickNext()} aria-label={translate('mam.blocks.slider.control.next')} tabIndex={0}>
            <span className="mam-ico19" />
          </button>
        </div>
      )}
      {showDots && (
        <ul className={`mam-dots ${playing ? "slick-playing" : ""}`} role="list">
          {Array.from(Array(slideCount).keys()).map((value, index) => (
            <li key={index} className={`${index === activeSlide ? "slick-active " : ""}${!playing ? "paused" : ""}`}
                onClick={() => sliderRef?.current?.slickGoTo(index)} role="listitem" tabIndex={0}>
              <div id={`loader-${index}`} tabIndex={-1} />
            </li>
          ))}
        </ul>
      )}
      {showPause && (
        <button className="pause-control" aria-label={translate(playing ? 'mam.blocks.slider.control.pause' : 'mam.blocks.slider.control.play')} onClick={playPause} role="button" tabIndex={0}>
          <span className={`${playing ? 'mam-ico41' : 'mam-ico37'}`} />
        </button>
      )}
    </div>
  );
}
